export const environment = {
  production: true,

  authority:
    'https://login.microsoftonline.com/344979d0-d31d-4c57-8ba0-491aff4acaed/',
  clientId: '4bbc5021-228a-412d-a0ac-77b01f117855',

  redirectUri: 'https://help.uade.edu.ar', //cambiar
  apiURL: 'https://helpapi.uade.edu.ar/api', //cambiar

  graphApiURL: 'https://graph.microsoft.com/v1.0',
  scope: 'api://2cf9f2fe-02f5-4a69-bb68-9bcd7569075b/access_as_user',
};
